import locale from 'antd/locale/ru_RU'
import { ConfigProvider } from 'antd'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { CSSProperties, forwardRef, ReactNode } from 'react'

export interface IDisabledTimes {
  disabledHours: () => number[]
  disabledMinutes: (hour: number) => number[]
  disabledSeconds: (hour: number, minute: number) => number[]
}

interface IProps {
  startTs: number
  endTs: number

  onChange: (startTs: number, endTs: number) => void
  disabledDate?: (date: number, type: string, from: number) => boolean
  withTime?: boolean
  disabled?: boolean
  allowSelectInFuture?: boolean
  open?: boolean
  placement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight'
  className?: string
  panelStyle?: CSSProperties
  needConfirm?: boolean
  getPopupContainer?: (node: HTMLElement) => HTMLElement
  disabledRangeTime?: (date: number, range: 'start' | 'end', from: number) => Partial<IDisabledTimes>
  renderExtraFooter?: ReactNode
  panelRender?: (originPanel: ReactNode) => ReactNode
  handleEditingRangeChange?: (editingRange: 'start' | 'end') => void
}

const { RangePicker } = DatePicker

const AntDateRangePicker = forwardRef<any, IProps>((props, ref) => {
  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: '#722ed1',
          colorPrimaryHover: '#9254de',
          colorPrimaryActive: '#531dab',
          colorPrimaryBg: '#f9f0ff',
          motion: true,
        },
      }}
    >
      <RangePicker
        ref={ref}
        style={props.panelStyle}
        needConfirm={props.needConfirm}
        popupClassName={props.className}
        placement={props.placement}
        getPopupContainer={props.getPopupContainer}
        panelRender={props.panelRender}
        renderExtraFooter={() => props.renderExtraFooter}
        open={props.open}
        showTime={props.withTime ? { format: 'HH:mm:ss' } : false}
        format={props.withTime ? 'DD.MM.YYYY HH:mm:ss' : 'DD.MM.YYYY HH:mm'}
        disabledTime={(date: dayjs.Dayjs, range: 'start' | 'end', info: { from?: dayjs.Dayjs }) => {
          if (props.disabledRangeTime)
            return props.disabledRangeTime(
              date ? date.unix() * 1000 : null,
              range,
              info?.from ? info.from.unix() * 1000 : null
            )
        }}
        onChange={(value: [dayjs.Dayjs, dayjs.Dayjs]) => {
          if (props.withTime) return
          if (value === null) {
            props.onChange(null, null)
          } else {
            props.onChange(value[0] ? value[0].unix() * 1000 : null, value[1] ? value[1].unix() * 1000 : null)
          }
        }}
        onFocus={(_, info: { range: 'start' | 'end' }) => {
          if (props.handleEditingRangeChange) props.handleEditingRangeChange(info?.range ? info.range : null)
        }}
        allowClear={true}
        disabledDate={(
          date: dayjs.Dayjs,
          info: {
            type: 'date' | 'month' | 'year' | 'decade'
            from?: dayjs.Dayjs
          }
        ) => {
          let disabledDateRes = false
          if (props.disabledDate)
            disabledDateRes = props.disabledDate(
              date.unix() * 1000,
              info.type,
              info?.from?.isValid() ? info?.from.unix() * 1000 : null
            )
          if (!props.allowSelectInFuture) disabledDateRes = disabledDateRes || disabledFutureDates(date, info)
          return disabledDateRes
        }}
        value={[props.startTs ? dayjs(props.startTs) : null, props.endTs ? dayjs(props.endTs) : null]}
        disabled={props.disabled}
        onOk={(value: [dayjs.Dayjs, dayjs.Dayjs]) => {
          props.onChange(value[0] ? value[0].unix() * 1000 : null, value[1] ? value[1].unix() * 1000 : null)
        }}
      />
    </ConfigProvider>
  )
})

const disabledFutureDates = (date, info) => {
  if (info.type === 'date') {
    return date.isAfter(dayjs().add(1, 'day'))
  }
}

export default AntDateRangePicker
